import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'

export default class extends Controller {
  static targets = [
    'admin',
    'super',
    'orgsBox',
    'orgs',
    'teamAdmin',
    'teamsBox',
    'teams',
    'adminBox',
    'referee',
    'refereeBox'
  ]

  connect() {
    if(this.hasOrgsTarget) {
      $(this.orgsTarget).select2()
    }
    if(this.hasTeamsTarget) {
      $(this.teamsTarget).select2()
    }
    if(this.hasAdminTarget) {
      this.toggleAdmin()
    }
    if(this.hasTeamAdminTarget) {
      this.toggleTeamAdmin()
    }
    if(this.hasRefereeTarget) {
      this.toggleReferee()
    }
  }

  toggleAdmin() {
    if(this.adminTarget.checked) {
      if(this.hasAdminBoxTarget) {
        this.adminBoxTarget.classList.remove('hide')
      }
      if(this.hasOrgsBoxTarget) {
        this.orgsBoxTarget.classList.remove('hide')
      }
      if(this.hasSuperTarget) {
        this.superTarget.removeAttribute('disabled')
      }
    } else {
      if(this.hasAdminBoxTarget) {
        this.adminBoxTarget.classList.add('hide')
      }
      if(this.hasOrgsBoxTarget) {
        this.orgsBoxTarget.classList.add('hide')
      }
      if(this.hasSuperTarget) {
        this.superTarget.setAttribute('disabled', 'disabled')
      }
    }
  }

  toggleTeamAdmin() {
    if(this.teamAdminTarget.checked) {
      if(this.hasTeamsBoxTarget) {
        this.teamsBoxTarget.classList.remove('hide')
      }
    } else {
      if(this.hasTeamsBoxTarget) {
        this.teamsBoxTarget.classList.add('hide')
      }
    }
  }

  toggleReferee() {
    if(this.refereeTarget.checked) {
      if(this.hasRefereeBoxTarget) {
        this.refereeBoxTarget.classList.remove('hide')
      }
    } else {
      if(this.hasRefereeBoxTarget) {
        this.refereeBoxTarget.classList.add('hide')
      }
    }
  }
}